import { Box, Button, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import QuestionAnswerFormRiskProfile from './QuestionAnswerFormRiskProfile'
import QuestionAnswerFormBase from './QuestionAnswerFormBase'
import QuestionAnswerFormProduit from './QuestionAnswerFormProduit'
import QuestionAnswerFormBourse from './QuestionAnswerFormBourse'
import QuestionAnswerFormImmobilier from './QuestionAnswerFormImmobilier'
import QuestionAnswerFinal from './QuestionAnswerFinal'
import FinanceInterest from './FinanceInterest'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ProfilInvesti({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [openRiskProfile, setOpenRiskProfile] = useState(false)
  const [openFiKnowledge, setOpenFiKnowledge] = useState(-1)
  const [openFi, setOpenFi] = useState(false)
  let w_tfknowledge = localStorage.getItem('w-tfknowledge')
  let w_finterest = localStorage.getItem('w-finterest')
  let w_fprofile = sessionStorage.getItem('w-fprofile')
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    if (w_tfknowledge) {
      setOpenFiKnowledge(1)
    }
    if (w_finterest) {
      setOpenFi(true)
    }
    if (w_fprofile) {
      setOpenRiskProfile(true)
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const questionnaire = params.get('questionnaire')

    if (
      location.hash === '#profil-risque' ||
      questionnaire === 'profil-risque' ||
      location.pathname.toLowerCase().endsWith('/profil-risque')
    ) {
      setOpenRiskProfile(true)
      return
    }

    if (
      location.hash === '#connaissance-financiere' ||
      questionnaire === 'connaissance-financiere' ||
      location.pathname.toLowerCase().endsWith('/connaissance-financiere')
    ) {
      setOpenFiKnowledge(1)
      return
    }

    if (
      location.hash === '#centres-interet-financier' ||
      questionnaire === 'centres-interet-financier' ||
      location.pathname.toLowerCase().endsWith('/centres-interet-financier')
    ) {
      setOpenFi(true)
    }
  }, [location.hash, location.pathname, location.search])
  useEffect(() => {
    if (w_tfknowledge) {
      if (openFiKnowledge === 0) {
        addAccDone()
      }
    }
  }, [openFiKnowledge])

  // const sleep = (ms) => {
  //     return new Promise((resolve) => setTimeout(resolve, ms))
  //   }
  const addAccDone = async () => {
    if (w_tfknowledge) {
      await makePostRequest(
        '/api/app/user-wizard/',
        { step: w_tfknowledge, completed: true, skip: true },
        {},
        true,
      )
      // await sleep(2000)
      dispatch(setUserWizardDone({ step: w_tfknowledge, completed: true, skip: true }))
      localStorage.removeItem('w-tfknowledge')
      navigate('/')
    }
  }
  return (
    <>
      {openRiskProfile && (
        <QuestionAnswerFormRiskProfile
          oldData={oldData}
          updateReports={updateReports}
          setOpenRiskProfile={setOpenRiskProfile}
        />
      )}
      {openFiKnowledge === 1 && (
        <QuestionAnswerFormBase
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 2 && (
        <QuestionAnswerFormProduit
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 3 && (
        <QuestionAnswerFormBourse
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 4 && (
        <QuestionAnswerFormImmobilier
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 5 && (
        <QuestionAnswerFinal
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFi && <FinanceInterest updateReports={updateReports} setOpenFi={setOpenFi} />}

      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.investorProfile')}
          </WTypography>
        </Box>

        <Box minWidth={3} mb={6} mt={4} height={'100%'}>
          <WTypography sx={{ color: 'gray' }} component={'div'} className="no-drag">
            {t('monPatrimoine.risk')}{' '}
            <Button
              onClick={() => setOpenRiskProfile(true)}
              startIcon={<FontAwesomeIcon icon={faInfo} />}
              sx={{
                minWidth: '23px',
                minHeight: '21px',
                backgroundColor: 'white',
                borderRadius: '50%',
                '& .MuiButton-startIcon': { margin: 0, '& svg': { fontSize: '12px' } },
                '&:hover': { backgroundColor: 'white !important' },
              }}
            ></Button>
          </WTypography>
          <WTypography component={'div'} variant="h6">
            {oldData?.risque_score}
          </WTypography>
          <WTypography sx={{ color: 'gray', marginTop: 1 }} component={'div'} className="no-drag">
            {t('monPatrimoine.knowledge')}{' '}
            <Button
              onClick={() => setOpenFiKnowledge(1)}
              startIcon={<FontAwesomeIcon icon={faInfo} />}
              sx={{
                minWidth: '23px',
                minHeight: '21px',
                backgroundColor: 'white',
                borderRadius: '50%',
                '& .MuiButton-startIcon': { margin: 0, '& svg': { fontSize: '12px' } },
                '&:hover': { backgroundColor: 'white !important' },
              }}
            ></Button>
          </WTypography>
          <WTypography component={'div'} variant="h6">
            {oldData?.financiere_score}
          </WTypography>
          <WTypography sx={{ color: 'gray', marginTop: 1 }} component={'div'} className="no-drag">
            {t('monPatrimoine.elementsOfInterest')}{' '}
            <Button
              onClick={() => setOpenFi(true)}
              startIcon={<FontAwesomeIcon icon={faInfo} />}
              sx={{
                minWidth: '23px',
                minHeight: '21px',
                backgroundColor: 'white',
                borderRadius: '50%',
                '& .MuiButton-startIcon': { margin: 0, '& svg': { fontSize: '12px' } },
                '&:hover': { backgroundColor: 'white !important' },
              }}
            ></Button>
          </WTypography>
          {oldData?.finance_interest?.length > 0 ? (
            oldData?.finance_interest?.map((el, index) => (
              <WTypography key={index} component={'div'} variant="h6">
                {el}
              </WTypography>
            ))
          ) : (
            <WTypography component={'div'} variant="h6">
              {t('monPatrimoine.selectFinancialInterests')}
            </WTypography>
          )}
        </Box>
      </Card>
    </>
  )
}

export default ProfilInvesti
